import axiosHttp from "./interceptor.service";

const getProjectTransaction = ({
  sort,
  search,
  limit,
  page,
  status,
  startDate,
  endDate,
  month,
  timezone,
  statusList,
} = {}) => {
  return axiosHttp.get("/feedback/getProjTransaction", {
    params: {
      sort,
      search,
      limit,
      page,
      status,
      startDate,
      endDate,
      month,
      timezone,
      statusList,
    },
  });
};

const getMonthlyReport = ({
  sort,
  search,
  limit,
  page,
  startDate,
  endDate,
  department,
  category,
} = {}) => {
  return axiosHttp.get("/feedback/report", {
    params: {
      sort,
      search,
      limit,
      page,
      startDate,
      endDate,
      department,
      category,
    },
  });
};

const getProjectDownloadTransaction = ({
  startDate,
  endDate,
  statusList,
} = {}) => {
  return axiosHttp.get("/feedback/getProjDownTransaction", {
    params: {
      startDate,
      endDate,
      statusList,
    },
  });
};

const getProjectResponse = (id, data) => {
  return axiosHttp.get(`/feedback/getProjectResponse/${id}`, data);
};

const sendMail = (id, data) => {
  return axiosHttp.post(`/feedback/sendEmail/${id}`, data);
};

export {
  getProjectTransaction,
  getProjectDownloadTransaction,
  getMonthlyReport,
  getProjectResponse,
  sendMail,
};
